import React from 'react';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import '../styles/TermsOfServicePage.css';

const TermsOfServicePage = () => {
  return (
    <div className="terms-page">
      <NavBar />
      <div className="terms-container">
        <div className="terms-header">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last updated: March 2024</p>
        </div>

        <div className="terms-content">
          <section className="terms-section">
            <h2>1. Agreement to Terms</h2>
            <p>
              By accessing or using Pocket Videoke, you agree to be bound by these Terms of Service. 
              If you disagree with any part of the terms, you may not access our services.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. User Accounts</h2>
            <p>
              When you create an account with us, you must provide accurate and complete information. 
              You are responsible for maintaining the security of your account and any activities that occur under it.
            </p>
            <ul>
              <li>You must be at least 13 years old to use our services</li>
              <li>You are responsible for maintaining the confidentiality of your account credentials</li>
              <li>You agree to notify us immediately of any unauthorized access</li>
              <li>We reserve the right to terminate accounts at our discretion</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>3. Service Usage</h2>
            <p>
              Our services are provided "as is" and "as available." We may modify, suspend, 
              or discontinue any aspect of our services at any time.
            </p>
            <h3>Acceptable Use</h3>
            <p>You agree not to:</p>
            <ul>
              <li>Use our services for any illegal purposes</li>
              <li>Violate any intellectual property rights</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Transmit harmful code or content</li>
              <li>Interfere with other users' enjoyment of the service</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>4. Intellectual Property</h2>
            <p>
              All content, features, and functionality of Pocket Videoke are owned by us 
              or our licensors and are protected by copyright, trademark, and other intellectual 
              property laws.
            </p>
          </section>

          <section className="terms-section">
            <h2>5. Payment Terms</h2>
            <p>
              Certain features of our service may require payment. By choosing a paid service, you agree to:
            </p>
            <ul>
              <li>Pay all applicable fees</li>
              <li>Provide accurate billing information</li>
              <li>Accept our refund and cancellation policies</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>6. Limitation of Liability</h2>
            <p>
              In no event shall Pocket Videoke be liable for any indirect, incidental, special, 
              consequential, or punitive damages arising out of or relating to your use of our services.
            </p>
          </section>

          <section className="terms-section">
            <h2>7. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. We will notify users of any 
              material changes via email or through our platform.
            </p>
          </section>

          <section className="terms-section">
            <h2>8. Governing Law</h2>
            <p>
              These terms shall be governed by and construed in accordance with the laws of the Philippines, 
              without regard to its conflict of law provisions.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. Contact Information</h2>
            <p>
              For any questions about these Terms of Service, please contact us at:
            </p>
            <div className="contact-info">
              <p>Email: legal@pocketvideoke.com</p>
              <p>Address: Manila, Philippines</p>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfServicePage; 